// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1371":"f989258a","3376":"f989258a","3766":"f989258a","4918":"f989258a","9684":"6ee0f1eb","9777":"f989258a"}[chunkId] + ".chunk.css";
};